import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from './app/store';
import Map from './components/Map';
import './styles/App.css';
import RightWindow from './components/RightWindow';
import Login from './components/Login';
import DriverInfo from './components/DriverInfo';
import API from './API/mainApi';

function App() {
  const [isLoad, setIsLoad] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [showAuthWindow, setShowAuthWindow] = useState(false);
  const [showDriverWindow, setShowDriverWindow] = useState(false);
  const [selectedMarkerId, setSelectedMarkerId] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const data = await API.checkAuth();
      data?.status === 200 ? setIsAuth(true) : setIsAuth(false);
      setIsLoad(true);
    };
    checkAuth();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAuthWindow(!isAuth);
    }, 1500);
    return () => clearTimeout(timer);
  }, [isLoad, isAuth]);

  const handleMarkerClick = (markerId) => {
    setSelectedMarkerId(markerId);
    setShowDriverWindow(true);
  };

  const handleCloseDriverWindow = () => {
    setShowDriverWindow(false);
    setSelectedMarkerId(null);
  };

  return (
    <Provider store={store}>
      <div className="App">
        <Map mode="view" onMarkerClick={handleMarkerClick} />
        <RightWindow show={showAuthWindow}>
          <Login setIsAuth={setIsAuth} />
        </RightWindow>
        <RightWindow show={showDriverWindow}>
          <DriverInfo markerId={selectedMarkerId} onClose={handleCloseDriverWindow} />
        </RightWindow>
        {/* <div className="info-panel">
          <h3>BlaBlaBam</h3>
        </div> */}
      </div>
    </Provider>
  );
}

export default App;